export default (node) => {
  // Only activate on mobile screens
  if (window.matchMedia('(min-width: 1024px)').matches) return;

  const hotspots = node.querySelectorAll('[data-hotspot]');
  if (!hotspots.length) return;

  hotspots.forEach((hotspot) => {
    hotspot.addEventListener('click', (e) => {
      e.stopPropagation();

      const wrapper = hotspot.closest('[data-hotspot-wrapper]');
      const bubble = wrapper.querySelector('[data-bubble]');

      const isOpen = bubble.classList.contains('!opacity-100');

      // Close all other bubbles
      node.querySelectorAll('[data-bubble]').forEach((el) => {
        if (el.classList.contains('!opacity-100')) {
          el.classList.remove('!opacity-100');
          el.classList.add('opacity-0');
        }
      });

      // Toggle this one
      if (!isOpen) {
        bubble.classList.remove('opacity-0');
        bubble.classList.add('!opacity-100');
      }
    });
  });

  // Close bubbles on outside click
  document.addEventListener('click', (e) => {
    if (!node.contains(e.target)) {
      node.querySelectorAll('[data-bubble]').forEach((el) => {
        if (el.classList.contains('!opacity-100')) {
          el.classList.remove('!opacity-100');
          el.classList.add('opacity-0');
        }
      });
    }
  });
};
